module.exports = __webpack_public_path__ + "img/lages.cc3e2169.jpeg";